module.exports = "img/element-icons/room/default_doc.a42767c.svg";